import { Button, Form, Input, Spin, notification } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import {
  checkEmployeesOvertimeFourHoursInTwoDayType,
  checkEmployeesOvertimeType,
  checkIsUsersDublicate,
  dataForOvertimeUsersTable,
} from 'shared/helpers/utils';
import { EditOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/store';
import { overtimeActions } from 'entities/overtime/model/Overtime';
import { Link, useNavigate } from 'react-router-dom';
import ModalCancelSubmit from 'shared/components/modalCancelSubmit/ModalCancelSubmit';
import Breadcrumbs from 'shared/components/breadcrumbs/Breadcrumbs';
import CommonTable from 'features/tables/commonTable';
import { ExcelOvertimeCompensationTypeToFront, OvertimeStatusToBack } from 'shared/enums/overtime';
import { useLazyGetEmployeesQuery } from 'app/services/edpApiV1/employees';
import { OvertimeUserPreparedInfo, TCommonColumns } from 'shared/types/overtime.types';
import { TUserOvertimeInfo } from 'shared/types/overtime.types';
import { useCreateOvertimeMutation, useCreateOvertimeUserMutation } from 'app/services/edpApiV1/overtime';
import { checkOvertimeCompensationTypeToBack } from 'shared/helpers/type-check';
import EmployeeInput from 'features/absence/madalAddOneAbsence/employeeInput';
import { TDivisionEmployees } from 'shared/types/types';
import { useLazyGetDivisionEmployeesQuery } from 'app/services/edpApiV1/viewer';
import moment, { Moment } from 'moment';
import { PICKER_TIME_MASK, SERVER_DATE_MASK } from 'shared/constants';
import { validateExcelDataOvertime } from 'shared/helpers/validate';
import {
  NOT_PROVIDED_DATE_OVERTIME,
  NOT_PROVIDED_TIME_OVERTIME,
  WORK_TIME_OVER_MESSAGE_OVERTIME,
} from 'shared/constants/overtime';
import { addZeroToStart } from 'shared/helpers/string';
import dayjs from 'dayjs';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { viewerModel } from 'entities/viewer';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import { uiModel } from 'entities/ui';
import { RvdTabs } from 'features/rvd';
import UploadExcell, { calcTime, excelToDate } from '../uploadExcell/UploadExcell';
import style from './index.module.scss';
import OvertimeSidebar from './sidebar/OvertimeSidebar';

const breadCrumbs = [
  { name: 'Сверхурочные', link: '/overtime' },
  { name: 'Создать заявку на СУ', link: `/overtime/new` },
];
const FORM_ITEM_NAME = 'signatoryOvertimeCreate';
const HOURS_CAN_WORK = 4;

const CreateOvertimeRequest = () => {
  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const dispatch = useAppDispatch();
  const currentOvertime = useAppSelector(state => state.entities.overtime.overtime);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<TUserOvertimeInfo | undefined>();
  const [isSidebarCreateOpen, setIsSidebarCreateOpen] = useState<boolean>(false);
  const [isSidebarUpdateOpen, setIsSidebarUpdateOpen] = useState<boolean>(false);
  const [excellFetching, setExcellFetching] = useState<boolean>(false);
  const [signatory, setSignatory] = useState<TDivisionEmployees | null>(null);
  const [getSignatories, { data: signatories }] = useLazyGetDivisionEmployeesQuery();
  const [overtimeCreating, setOvertimeCreating] = useState<boolean>(false);
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);
  const currentOrganizationid = useAppSelector(viewerModel.me.selectors.getMeOrganizationId);

  const [createOvertimeRequest, { isLoading: isOvertimeCreateLoading }] = useCreateOvertimeMutation();
  const [createOvertimeUserRequest] = useCreateOvertimeUserMutation();

  const navigate = useNavigate();
  const [getEmployees] = useLazyGetEmployeesQuery();

  useEffect(() => {
    if (signatory) {
      form.setFieldValue(FORM_ITEM_NAME, signatory?.id);
      getSignatories({
        page: 1,
        size: 10,
        search: `${signatory.lastName} ${signatory.name} ${signatory.middleName}`,
        allAvailableOrganizations,
      });
    }
  }, [signatory]);

  const columns: TCommonColumns = [
    {
      title: 'Дата работ',
      dataIndex: 'toDate',
      key: 'toDate',
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Табельный номер',
      dataIndex: 'personnelNumber',
      key: 'personnelNumber',
    },
    {
      title: 'Подразделение',
      dataIndex: 'division',
      key: 'division',
    },
    {
      title: 'Время работы',
      dataIndex: 'workDuration',
      key: 'workDuration',
    },
    {
      title: 'Способ компенсации',
      dataIndex: 'type',
      key: 'type',
    },
  ];

  const openDrawerCreate = () => {
    setIsSidebarCreateOpen(true);
  };

  const onCloseCreate = () => {
    setIsSidebarCreateOpen(false);
  };

  const onCloseUpdate = () => {
    setIsSidebarUpdateOpen(false);
  };

  const onFinishExcell = (overtimeUsers: unknown) => {
    const overtime = { ...currentOvertime, toDate: (overtimeUsers as TUserOvertimeInfo[])[0].toDate };
    overtime.employees = overtimeUsers as TUserOvertimeInfo[];
    dispatch(overtimeActions.setCurrent(overtime));
  };

  const onFinishCreate = (overtimeUser: TUserOvertimeInfo) => {
    const overtime = { ...currentOvertime };
    overtimeUser.id = Math.random();
    overtime.employees = [...currentOvertime.employees, overtimeUser];
    dispatch(overtimeActions.setCurrent(overtime));
    setIsSidebarCreateOpen(false);
  };

  const onFinishUpdate = (overtimeUser: TUserOvertimeInfo) => {
    const newOvertimeUsers = { ...currentOvertime }.employees.map(user => {
      if (user.id === overtimeUser.id) {
        return overtimeUser;
      }
      return user;
    });
    const newOvertime = { ...currentOvertime };
    newOvertime.employees = newOvertimeUsers;
    setCurrentUser(overtimeUser);
    setIsSidebarUpdateOpen(false);
    dispatch(overtimeActions.setCurrent(newOvertime));
  };

  const getUserByPersonnelNumber = async (personnelNumber: string | undefined): Promise<TDivisionEmployees> => {
    const employee = await getEmployees({
      isActive: true,
      page: 1,
      size: 1,
      personnelNumber: personnelNumber,
      allAvailableOrganizations,
      organizationId: currentOrganizationid,
    }).unwrap();
    return {
      id: employee.data[0].id,
      division: employee.data[0].division!.name,
      personnelNumber: employee.data[0].personnelNumber,
      lastName: employee.data[0].lastName,
      middleName: employee.data[0].middleName,
      name: employee.data[0].name,
      position: '',
    };
  };

  const rowClicked = (id: number) => {
    const user = currentOvertime.employees.find(item => item.id === id);
    if (user) {
      setCurrentUser(user);
    }
    setIsSidebarUpdateOpen(prev => !prev);
  };

  const checkMaxTimeOver = useCallback(() => {
    const employeesWorkHours = {};
    const maxTimeToWork = 4 * 60 * 60 * 1000;
    for (const employee of currentOvertime.employees) {
      const userId = employee.userInfo.id;
      let workingHours = employeesWorkHours[userId || 0];
      const diff = dayjs(employee.endTime, PICKER_TIME_MASK).diff(dayjs(employee.startTime, PICKER_TIME_MASK));
      workingHours = workingHours ? workingHours + diff : diff;
      // Убрана проверка т.к. она не должна работать для локального персонала
      // if (workingHours > maxTimeToWork) {
      //   throw new Error(WORK_TIME_OVER_MESSAGE_OVERTIME);
      // }
      employeesWorkHours[userId || 0] = workingHours;
    }
  }, [currentOvertime.employees]);

  const isDiffLessThanNeed = (start: Moment, end: Moment) => {
    const startHour = start.hour();
    const startMinute = start.minute();
    const endHour = end.hour();
    const endMinute = end.minute();
    let diffHour = 0;

    const minutesDiff = endMinute - startMinute;
    let resultMinute = minutesDiff;

    if (minutesDiff < 0) {
      diffHour = 1;
      resultMinute = 60 + minutesDiff;
    }

    let resultHour = endHour - startHour - diffHour;

    if (resultHour < 0) {
      resultHour = 0;
    }

    return `${addZeroToStart(resultHour)}:${addZeroToStart(resultMinute)}`;
  };

  const createOvertime = async () => {
    if (checkIsUsersDublicate(currentOvertime.employees)) {
      notification.error({
        message: 'Пользователи в заявке дублируются',
      });
      return;
    }
    try {
      setOvertimeCreating(true);

      const employees: OvertimeUserPreparedInfo[] = currentOvertime.employees.map(user => ({
        employeeId: user.userInfo.id,
        endTime: user.endTime,
        startTime: user.startTime,
        toDate: user.toDate,
        type: checkOvertimeCompensationTypeToBack(user.type),
      }));

      checkEmployeesOvertimeFourHoursInTwoDayType(employees);
      checkEmployeesOvertimeType(employees);

      const overtimeIdObject = await createOvertimeRequest({
        status: OvertimeStatusToBack[currentOvertime.status],
        docSignatory: signatory!.personnelNumber,
        userComment: form.getFieldValue('comment'),
      }).unwrap();

      await createOvertimeUserRequest({ overtimeId: overtimeIdObject.id, employee: employees });
      notification.success({
        message: 'Заявка создана успешно',
      });
      setOvertimeCreating(false);

      dispatch(uiModel.Tabs.actions.setActive(RvdTabs.new));
      navigate('/overtime');
    } catch (e: any) {
      setOvertimeCreating(false);
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  const cancelModalOpen = () => {
    setModalOpen(true);
  };

  const cancelModalClose = () => {
    setModalOpen(false);
    dispatch(overtimeActions.clearCurrent());
    dispatch(uiModel.Tabs.actions.setActive(RvdTabs.new));
    navigate('/overtime');
  };

  const cancelModalSubmit = () => {
    setModalOpen(false);
  };

  const parseExcell = async (data: (string | number)[][]): Promise<TUserOvertimeInfo[]> => {
    let startPayloadLine = 0;
    let startPayloadFlag = false;
    const sygnatoryPersonnelNumber: string = data[2][3] as string;
    try {
      const excelDocSignatory = await getUserByPersonnelNumber(sygnatoryPersonnelNumber);
      setSignatory(excelDocSignatory);
    } catch (e) {
      notification.error({
        message: `Не найден подписант с ТН ${sygnatoryPersonnelNumber}`,
        duration: 0,
      });
    }
    const preparedUsers: TUserOvertimeInfo[] = [];
    setExcellFetching(true);

    for (let line = 0; line < data.length; line++) {
      if (startPayloadFlag && line >= startPayloadLine) {
        if (typeof data[line][0] === 'number') {
          let currentUserExcel: TDivisionEmployees | undefined;
          const currentUserPersonnelNumber = data[line][1] as string;
          try {
            currentUserExcel = await getUserByPersonnelNumber(currentUserPersonnelNumber);
          } catch (e) {
            notification.error({
              message: `Не найден пользователь с ТН ${currentUserPersonnelNumber}`,
              duration: 0,
            });
          }
          if (currentUserExcel) {
            const startTime = calcTime(data[line][6]);
            const endTime = calcTime(data[line][7]);
            const toDate = +data[line][5];
            const compensationType = data[line][8];
            try {
              validateExcelDataOvertime(data, line);
              const preparedUser: TUserOvertimeInfo = {
                id: Math.random() * 1000000,
                toDate: excelToDate(toDate),
                startTime,
                endTime,
                type: ExcelOvertimeCompensationTypeToFront[compensationType],
                userInfo: currentUserExcel,
                created: moment().format(SERVER_DATE_MASK),
              };

              // Убрана проверка т.к. она не должна работать для локального персонала
              // const startHour = moment(startTime, PICKER_TIME_MASK);
              // const endHour = moment(endTime, PICKER_TIME_MASK);
              // const timeDiffString = isDiffLessThanNeed(startHour, endHour);
              // const timeDiff = moment(timeDiffString, PICKER_TIME_MASK);
              // if (timeDiff.hour() > HOURS_CAN_WORK) {
              //   throw new Error(WORK_TIME_OVER_MESSAGE_OVERTIME);
              // } else if (timeDiff.hour() === HOURS_CAN_WORK && timeDiff.minute() > 0) {
              //   throw new Error(WORK_TIME_OVER_MESSAGE_OVERTIME);
              // }
              preparedUsers.push(preparedUser);
            } catch (e: unknown) {
              const errorMessage = (e as Error).message;
              if (
                // Убрана проверка т.к. она не должна работать для локального персонала
                // errorMessage === WORK_TIME_OVER_MESSAGE_OVERTIME ||
                errorMessage === NOT_PROVIDED_DATE_OVERTIME ||
                errorMessage === NOT_PROVIDED_TIME_OVERTIME
              ) {
                notification.error({
                  message: `${currentUserPersonnelNumber}: ${errorMessage}`,
                  duration: 0,
                });
              } else {
                notification.error({
                  message: 'Не удалось прочитать файл Excel, проверьте правильность заполнения',
                  duration: 0,
                });
              }
            }
          }
        } else {
          break;
        }
      }
      if (data[line][0].toString().includes('№') && data[line][1] === 'Табельный номер') {
        startPayloadLine = line + 2;
        startPayloadFlag = true;
      }
    }
    setExcellFetching(false);
    return preparedUsers;
  };

  const deleteUser = (id: number | string) => {
    const overtime = { ...currentOvertime };
    const users = overtime.employees.filter(user => user.id !== id);
    overtime.employees = users;
    dispatch(overtimeActions.setCurrent(overtime));
    setIsSidebarUpdateOpen(false);
  };

  return (
    <>
      <div className={style['top-side']}>
        <h3 className={style.title}>
          <Breadcrumbs breadCrumbs={breadCrumbs} />
        </h3>
        <div className={style.buttons}>
          <UploadExcell onFinishExcell={onFinishExcell} parseExcell={parseExcell} />
          <Button onClick={openDrawerCreate}>
            <EditOutlined />
            Добавить вручную
          </Button>
          {/* <Link to="/overtime"> */}

          <Button
            type="primary"
            disabled={currentOvertime.employees.length < 1 || !signatory || allAvailableOrganizations}
            onClick={createOvertime}
            loading={isOvertimeCreateLoading || excellFetching || overtimeCreating}
          >
            Создать
          </Button>

          {/* </Link> */}

          <Button onClick={cancelModalOpen}>Отмена</Button>
          <ModalCancelSubmit open={modalOpen} onStay={cancelModalSubmit} onQuit={cancelModalClose} />
        </div>
      </div>
      <OvertimeSidebar
        onClose={onCloseCreate}
        isOpen={isSidebarCreateOpen}
        onOk={onFinishCreate}
        currentOvertime={currentOvertime}
      />
      <OvertimeSidebar
        onClose={onCloseUpdate}
        isOpen={isSidebarUpdateOpen}
        onOk={onFinishUpdate}
        currentOvertime={currentOvertime}
        currentUser={currentUser}
        remove={deleteUser}
      />
      <Spin spinning={excellFetching || overtimeCreating}>
        <CommonTable
          dataSource={dataForOvertimeUsersTable(currentOvertime.employees)}
          columns={columns}
          currentPage={currentPage}
          currentSize={currentSize}
          setCurrentPage={setCurrentPage}
          setCurrentSize={setCurrentSize}
          total={currentOvertime.employees.length}
          onclickToRow={rowClicked}
          selfPaginated={true}
        />
      </Spin>
      <Form
        form={form}
        name="basic"
        layout="vertical"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={() => {}}
        autoComplete="off"
      >
        <EmployeeInput
          data={signatories}
          getEmployees={getSignatories}
          setEmployee={setSignatory}
          divisionName={signatory?.division}
          label="Выберите руководителя"
          rules={[{ required: true, message: 'Выберите руководителя!' }]}
          className="form-item-overtime"
          onChangeEmployee={() => {}}
          defaultUser={currentUser?.userInfo}
          formItemName={FORM_ITEM_NAME}
        />
        <Form.Item name={'comment'} label={'Введите комментарий'}>
          <Input placeholder="Введите комментарий" />
        </Form.Item>
      </Form>
    </>
  );
};

export default CreateOvertimeRequest;
